import React from 'react';
import {useResourceContext} from 'components/record/ResourceContext';
import {useRecordContext} from 'components/record/useRecordContext';
import {useDialogContext} from 'components/dialog/DialogContext';
import {useMutate} from 'hooks/useFetchData';
import {RecordType} from 'components/record/RecordContext';
import {toast} from 'react-toastify';
import {Button} from '@mui/material';
import {useListContext} from 'components/list/ListContext';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type UpdateData = any;

const UpdateConfirmButton = ({onSuccess, data, many = false}: {onSuccess?: () => void; data: UpdateData; many?: boolean}) => {
  const {resource, params} = useResourceContext();
  const {close} = useDialogContext();
  const {id} = useRecordContext();
  const {selected: ids} = useListContext();
  const [mutate] = useMutate<{item: RecordType; items: RecordType[]}>(many ? 'UPDATE_MANY' : 'UPDATE_ONE', resource, {
    variables: {...(many ? {ids} : {id}), ...params, payload: {...data}}
  });

  const handleUpdate = () => {
    if (typeof mutate === 'function') {
      mutate()
        .then((res) => {
          let itemName;
          if (res.data?.item) {
            itemName = res.data?.item.name || res.data?.item.id || '';
          }
          if (res.data?.items) {
            itemName = res.data?.items[0]?.name || res.data?.items[0]?.id || '';
          }
          if (itemName) {
            toast.success(`${resource} ${itemName} has been updated successfully!`);
            close();
            if (typeof onSuccess === 'function') {
              onSuccess();
            }
          }
        })
        .catch((error) => {
          if (error.message) {
            toast.error(error.message);
          }
        });
    }
  };

  return (
    <Button variant="contained" onClick={handleUpdate}>
      Confirm
    </Button>
  );
};

export default UpdateConfirmButton;
